import React from "react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import anyColorToHex from "@mapmycustomers/shared/util/color/anyColorToHex";

import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";

import styles from "./ColorField.module.scss";

const ColorField = ({ entity, field }: RegistryProps) => {
  const value = field.getValueFor(entity) as AnyColor;
  const hexValue = anyColorToHex(value);
  const isHex = value?.startsWith("#");

  return (
    <div className={styles.container}>
      <div className={styles.dot} style={{ backgroundColor: hexValue }}></div>
      {!isHex && <div className={styles.name}>{value}</div>}
    </div>
  );
};

export default ColorField;
